import React, {Component} from 'react';
import './style.css';
import SlideShow from "./SlideShow";

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            j: 5,
            imgs: [
                "./imgs/ba_cunovo.JPG",
                "./imgs/ba_cunovo2_z.JPG",
                "./imgs/ba_cunovo_bobrie ohryzy_z.JPG",
                "./imgs/ba_meander_mlaky_z.JPG",

                "./imgs/beckov_i.JPG",
                "./imgs/bor_niz_holbickovci_z.JPG",
                "./imgs/bor_niz_jurikovci_z.JPG",
                "./imgs/bor_niz_morava_kompa_z.JPG",

                "./imgs/cert_brana_gader_dol1_z.JPG",
                "./imgs/cert_brana_gader_dol2_z.JPG",
                "./imgs/cert_skala_hron_breznica_i.JPG",
                "./imgs/ch_v_borove2_z.JPG",
                //"./imgs/",
            ],
        };
    }

    render() {
        return (
            <div className="App">
                <SlideShow
                    initJ={this.state.j}
                    imgs={this.state.imgs}
                />
            </div>
        );
    }
}

export default App;
